import { isServer } from './ssr';

export const STORAGE_KEYS = {
  NOTIFY_CHANGE_ADDRESS: 'notify-change-address',
  NOTIFY_CHANGE_DEFAULT_ADDRESS: 'notify-change-default-address',
  NOTIFY_ADD_NEW_ADDRESS: 'notify-add-new-address',
  OPEN_POST_FORM_URL: 'open-post-form-url',
  OPEN_POST_FORM_URL_PAYLOAD: 'open-post-form-url-payload',
  OPEN_GET_FORM_URL: 'open-get-form-url',
  OPEN_GET_FORM_URL_PAYLOAD: 'open-get-form-url-payload',
  SET_PAYMENT_ID: 'set-payment-id',
  SAVE_REFUND_ACCOUNT: 'save-refund-account',
  BUSINESS_ID: 'businessId',
  REFERRER: 'referrer',
  TOKEN: 'token',
};

export type StorageKeyType = keyof typeof STORAGE_KEYS;

export function getStorageKey(key: StorageKeyType) {
  return `hawk-${STORAGE_KEYS[key]}`;
}

export function getStorageData(key: StorageKeyType) {
  if (isServer()) return null;
  return localStorage.getItem(getStorageKey(key));
}

export function getStorageJSONData<T>(key: StorageKeyType) {
  try {
    const saved = getStorageData(key);
    if (!saved) {
      return null;
    }

    return JSON.parse(saved) as T;
  } catch {
    return null;
  }
}

export function setStorageData(key: StorageKeyType, data: string) {
  return localStorage.setItem(getStorageKey(key), data);
}

export function setStorageJSONData<T>(key: StorageKeyType, data: T) {
  return localStorage.setItem(getStorageKey(key), JSON.stringify(data));
}

export function removeStorageData(key: StorageKeyType) {
  return localStorage.removeItem(getStorageKey(key));
}

export const deleteAllLocalStorage = () => {
  localStorage.clear();
};
